import React from 'react';
import Hero from '../../components/public/Hero';

const Commitment = () => {
    const commitmentPoints = [
        {
            title: 'Transparent Communication',
            description: 'We explain our reasoning clearly. You understand not just what we recommend, but why. No hidden agendas, no unclear language, no confusion.',
            color: 'coral'
        },
        {
            title: 'Ethical Guidance',
            description: 'Our advice prioritizes your long-term stability over our short-term benefit. We recommend what you need, not what benefits us most.',
            color: 'gray'
        },
        {
            title: 'Reality-Based Advice',
            description: 'We work with your actual situation, not idealized versions. Recommendations are grounded in your real circumstances, constraints, and capabilities.',
            color: 'gray'
        },
        {
            title: 'Emotional Sensitivity',
            description: 'We understand that economic matters carry emotional weight. We respect financial anxiety, hope, and concern. Guidance is delivered with care.',
            color: 'coral'
        }
    ];

    const values = [
        {
            icon: '🎯',
            title: 'Quality Excellence',
            description: 'We are committed to delivering the highest quality in everything we do, ensuring exceptional results and lasting impact.'
        },
        {
            icon: '🤝',
            title: 'Integrity & Trust',
            description: 'We operate with complete transparency and honesty, building relationships based on trust and mutual respect.'
        },
        {
            icon: '💡',
            title: 'Innovation',
            description: 'We continuously evolve and adapt, embracing new ideas and technologies to provide cutting-edge solutions.'
        },
        {
            icon: '🌱',
            title: 'Sustainable Growth',
            description: 'We focus on long-term success and sustainable practices that benefit our clients, community, and environment.'
        }
    ];

    return (
        <div className="commitment-page">
            <Hero
                title="Our Commitment to You"
                subtitle="Our Promise"
                description="Trust is earned through consistent demonstration of values, not through claims"
            />

            {/* Intro Section */}
            <section className="commitment-intro-section">
                <div className="container">
                    <div className="commitment-intro-text">
                        <p>
                            Trust is earned through consistent demonstration of values, not through claims.
                            At <strong>Yathartha</strong>, our commitment shapes every interaction, every recommendation, every conversation.
                        </p>
                    </div>
                </div>
            </section>

            {/* Commitment Points Grid */}
            <section className="commitment-points-section">
                <div className="container">
                    <div className="commitment-points-grid">
                        {commitmentPoints.map((point, index) => (
                            <div
                                key={index}
                                className={`commitment-point-box ${point.color}`}
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <h3>{point.title}</h3>
                                <p>{point.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Stability Quote */}
            <section className="stability-quote-section">
                <div className="container">
                    <div className="quote-card">
                        <h2>Your stability matters more than speed.</h2>
                        <p>
                            We measure success not by how quickly you act, but by how sustainably you progress.
                            Lasting results take precedence over impressive timelines.
                        </p>
                    </div>
                </div>
            </section>

            {/* Values Grid */}
            <section className="values-grid-section">
                <div className="container">
                    <div className="section-title">
                        <h2 className="section-heading">Our Core Values</h2>
                        <p className="section-description">
                            The principles that guide everything we do
                        </p>
                    </div>
                    <div className="values-grid">
                        {values.map((value, index) => (
                            <div
                                key={index}
                                className="value-card"
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="value-icon">{value.icon}</div>
                                <h3>{value.title}</h3>
                                <p>{value.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Promise Section */}
            <section className="promise-section">
                <div className="container">
                    <div className="promise-card">
                        <div className="promise-icon">🌟</div>
                        <h2>Our Promise to You</h2>
                        <p>
                            We promise to be your trusted partner in achieving clarity and success.
                            With dedication, expertise, and unwavering support, we'll guide you every
                            step of the way. Your goals become our mission, and your success is our
                            greatest achievement.
                        </p>
                        <div className="promise-signature">
                            <p className="signature-text">— The Yathartha Team</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <div className="container">
                    <div className="cta-content">
                        <h2>Experience Our Commitment Firsthand</h2>
                        <p>Join hundreds who have transformed their journey with our dedicated support</p>
                        <div className="cta-buttons">
                            <a href="/begin-with-clarity" className="cta-button primary">
                                Start Your Journey
                            </a>
                            <a href="/contact" className="cta-button secondary">
                                Get in Touch
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Commitment;
